var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trial-banner"},[_c('div',{staticClass:"inner-wrap"},[_c('div',{staticClass:"trial-bar-wrapper"},[_c('div',{staticClass:"text-wrapper"},[_c('p',{staticClass:"header",domProps:{"innerHTML":_vm._s(_vm.headerText)}}),(!_vm.isMobile)?_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.promotionText))]):_vm._e()]),_c('router-link',{staticClass:"secondary-button",attrs:{"to":`${_vm.$t(
          'path_payment_proposition',
          _vm.$routeLocale
        )}/${_vm.primaryPropositionId}`}},[_vm._v(" "+_vm._s(_vm.$t('trial_bottom_banner_action_link'))+" ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }